<template>
  <div>
    <v-menu
      v-model="showMenu"
      :close-on-content-click="false"
      offset-y
      max-width="506px"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="color-picker-menu-activator d-flex align-center cursor-pointer"
        >
          <v-avatar
            :color="value || '#000000'"
            size="32"
            class="rounded mr-3"
          >
            <span></span>
          </v-avatar>
          <span class="text-body-2">{{ selectedColorName || 'Välj färg' }}</span>
          <v-icon small class="ml-2">mdi-chevron-down</v-icon>
        </div>
      </template>
      <v-sheet class="overflow-y-auto pa-2">
        <color-picker
          :value="value"
          @input="$emit('input', $event)"
          :show-vuetify-colors="showVuetifyColors"
          :show-hex-colors="showHexColors"
        ></color-picker>
      </v-sheet>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ColorPicker from '@/components/onboarding/ColorPicker.vue'

export default {
  name: 'ColorPickerMenu',
  components: {
    ColorPicker
  },
  props: {
    value: String,
    showVuetifyColors: {
      type: Boolean,
      default: true
    },
    showHexColors: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    showMenu: false
  }),
  computed: {
    ...mapState(
      {
        vuetifyColors: state => state.vuetifyColors
      }
    ),
    selectedColorName: function () {
      const vuetifyColor = this.vuetifyColors.find(c => c.name === this.value || c.hex === this.value)
      return vuetifyColor ? vuetifyColor.name_sv : this.value
    }
  }
}
</script>
